import { priceComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';
import { Fee } from 'generated/graphql';

export type MostExpectiveItineraryBuilderReturnType = {
  add: (itineraryFee: Fee, position: number) => void;
  build: () => ReturnType<typeof createBestItineraryData>;
};
const MostExpensiveItineraryBuilder =
  (): MostExpectiveItineraryBuilderReturnType => {
    let mostExpensivePosition;
    let mostExpensive: Fee = {
      price: {
        amount: 0,
        currency: '',
      },
      type: {
        id: '',
        name: '',
      },
    };

    return {
      add(itineraryFee: Fee, position: number) {
        if (priceComparator(itineraryFee, mostExpensive) > 0) {
          mostExpensive = itineraryFee;
          mostExpensivePosition = position;
        }
      },
      build() {
        return createBestItineraryData(
          null,
          mostExpensive,
          mostExpensivePosition
        );
      },
    };
  };

export default MostExpensiveItineraryBuilder;
